// @ts-nocheck
import './index.css';

// Global styles (styles not confined to one component) go here
export {};
